const getBrandName = (dashboard) => {
  return dashboard?.getMasterOTP?.data?.[0]?.brandName || 'EcommNxt';
};

export default getBrandName;
